import React from "react"
import { Link } from "gatsby"

import { useBlogCategories } from "../../GraphQl/useBlogCategories"

export const BlogNav = () => {
  const items = useBlogCategories()
  return (
    <div className="grid grid-flow-col justify-end col-start-2 col-end-14 md:col-start-3 md:col-end-13 py-10 divide-x-2 divide-marphonaGold gap-x-5">
      <Link
        to="/blog"
        className="text-xl font-display"
        activeClassName="text-marphonaGold"
      >
        All
      </Link>
      {items.map(
        ({ slug, title, posts }) =>
          posts && (
            <Link
              to={`/blog/${slug && slug.current}`}
              className="text-xl font-display pl-5"
              activeClassName="text-marphonaGold"
            >
              {title}
            </Link>
          )
      )}
    </div>
  )
}
